import { render, staticRenderFns } from "./answerSheet.vue?vue&type=template&id=ea53cdce&scoped=true&"
import script from "./answerSheet.vue?vue&type=script&lang=js&"
export * from "./answerSheet.vue?vue&type=script&lang=js&"
import style0 from "./answerSheet.vue?vue&type=style&index=0&id=ea53cdce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea53cdce",
  null
  
)

export default component.exports